/// <reference types="gtag.js" />

export * from './Ad';
export * from './AdManager';
export * from './AdProvider';
export * from './AdGuest';
